import { FoaPart, type SourcingEventV2Dto } from "../../../../autogen/bff-api";

export const requiresStandstill = (event: SourcingEventV2Dto): boolean => {
  const part = event.eventContext.type === "Public" ? event.eventContext.foaPart : null;
  return part === FoaPart.PartIii || part === FoaPart.PartIv;
};
